import React, { ReactElement } from 'react';
import BillingPackageOld from '../../atoms/billing/BillingPackageOld';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { CustomStyledProps } from 'style/style';

const DivContainer = styled('div')`
  margin: 0 auto;
`;

const PackageListContainer = styled(`div`)`
  margin: 0 auto;
  max-width: ${({ maxWidth }: CustomStyledProps) => maxWidth && `${maxWidth}px`};
`;

const PackageList = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Line = styled('div')`
  height: 1px;
  border-bottom: 1px solid #cfd8e3;
  max-width: 865px;
  margin: 16px auto;
`;

interface BillingPackagesOldProps {
  packages: any;
  promoPackages: any;
  selected: any;
  selectPackage: any;
  withNewPackage: any;
  stepBilling: any;
  emailPromo: any;
  showPayment: any;
}

const BillingPackagesOld = ({
  packages,
  promoPackages,
  selected,
  selectPackage,
  withNewPackage,
  stepBilling,
  emailPromo,
  showPayment,
}: BillingPackagesOldProps): ReactElement => {
  const hasPromoPackage = promoPackages && promoPackages.length > 0;

  const renderPackages = packages => {
    const cards = packages.map(pkg => {
      if (!withNewPackage && pkg.packageVersion === 'new') {
        return false;
      } else {
        const recommended = withNewPackage
          ? pkg.packageVersion === 'new' && pkg.recommended
          : !hasPromoPackage && pkg.recommended;

        return (
          // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
          <BillingPackageOld
            key={pkg.identifier}
            selected={selected === pkg.identifier}
            selectPackage={selectPackage}
            credits={pkg.credits}
            promotional={pkg.promotional}
            identifier={pkg.identifier}
            currencyCharCode={pkg.currency.data.label_unicode}
            price={pkg.price}
            hasPromoPackage={hasPromoPackage}
            isRecommended={recommended}
            vatDetails={pkg.taxes}
            withNewPackage={withNewPackage}
            stepBilling={stepBilling}
            emailPromo={emailPromo}
            showPayment={showPayment}
          />
        );
      }
    });

    return <PackageList>{cards}</PackageList>;
  };

  return (
    <DivContainer>
      <PackageListContainer maxWidth={546}>
        {hasPromoPackage && promoPackages.length > 0 ? renderPackages(promoPackages) : null}
      </PackageListContainer>
      {hasPromoPackage && packages.length > 0 ? <Line /> : null}
      <PackageListContainer maxWidth={withNewPackage ? 1200 : 800}>
        {packages.length > 0 ? renderPackages(packages) : null}
      </PackageListContainer>
    </DivContainer>
  );
};

BillingPackagesOld.propTypes = {
  /** List of default packages */
  packages: PropTypes.arrayOf(PropTypes.object).isRequired,
  /** List of promo packages */
  promoPackages: PropTypes.arrayOf(PropTypes.object).isRequired,
  /** Function to handle selecting a package */
  selectPackage: PropTypes.func.isRequired,
  /** Signifies which package is selected */
  selected: PropTypes.string.isRequired,
};

export default BillingPackagesOld;
